import React from "react";
// redux
import { connect } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";

import Typography from "@material-ui/core/Typography";

import Container from "@material-ui/core/Container";
import { useState, useEffect } from "react";

//Actions
import {
  setClinic,
  setPatient,
  loginRequest,
  menuStaff,
  userStaff,
} from "../actions";
import Lottie from "lottie-react";
import listo from "../assets/static/cargando_pulso_corazon.json";

// services
import { authenticationService } from "../services/authenticationService";

function SignIn(props) {
  let history = useHistory();

  const [loginType, setLoginType] = useState("form");
  const [patientExist, setPatientExist] = useState(true);
  const [loading, setLoading] = useState(false);
  const [urlBackgroundImage, setUrlBackgroundImage] = useState("");

  // Obtener los parámetros GET de la URL
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const email = params.get("email");
  const password = params.get("password");
  const clinic = params.get("clinic");

  function handleClick(type) {
    //setLoading(true);
    setLoginType(type);
  }

  const handleSelectClinic = async () => {
    const tokens = await authenticationService.manualLogin(email, password);

    props.setClinic({
      cli_id: clinic,
    });

    if (tokens.access) {
      try {
        const resp = await authenticationService.login(
          email,
          null,
          null,
          clinic
        );

        props.setPatient(resp.patients);
        props.loginRequest(resp.ceroTramuser);
        props.userStaff(resp);
        console.log("hola", email);
        if (clinic == "12" || clinic == "27") {
          const permisoStaff = await authenticationService.permisoStaff(email);
          props.menuStaff(permisoStaff);
        }
        if (resp.ceroTramuser.user.is_staff) {
          history.push("/staff");
        } else {
          history.push("/dashboard");
        }
      } catch (error) {
        console.log("error", error);
        handleSelectClinic();
      }
    } else {
      //setEmailValidator(true);
      //setPasswordValidator(true);
      alert("Correo o contraseña incorrectos");
      //setLoading(false);
    }
  };

  useEffect(() => {
    handleSelectClinic();
  }, []);

  if (!props.clinic) history.push("/");

  return (
    <Container component="main" maxWidth="xs">
      <Lottie animationData={listo} />
    </Container>
  );
}

const mapStateToProps = (state) => ({
  faceAuth: state.faceAuth,
  user: state.user,
  clinic: state.clinic,
});

const mapDispatchToProps = {
  setClinic,
  setPatient,
  loginRequest,
  menuStaff,
  userStaff,
};

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
